/**
 * Created by ori on 20/09/16.
 */
import Auth from './Auth';
import User from './User';
// import BuildApi from './BuildApi';

export default state => ({
    auth: new Auth(state),
    user: new User(state),
    // buildApi: new BuildApi(state),
});


// WEBPACK FOOTER //
// ./src/js/actions/index.js